import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import authService from '../../services/authService';
import './Login.css';
import { validateEmail } from '../../utils/validation';

const Login = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        // Clear error when user starts typing
        if (error) setError('');
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (!validateEmail(formData.email)) {
            setError('Geçerli bir e-posta adresi giriniz.');
            setLoading(false);
            return;
        }

        try {
            const response = await authService.login(formData.email, formData.password);
            console.log('Login successful:', response);
            
            // Check if user needs to change password
            if (response.user.requiresPasswordChange) {
                navigate('/change-password');
            } else {
                // Redirect based on role
                if (response.user.role?.name === 'Commission Chair') {
                    navigate('/chair-dashboard');
                } else if (response.user.role?.name === 'Commission Member') {
                    navigate('/member-dashboard');
                } else {
                    navigate('/dashboard');
                }
            }
        } catch (err) {
            console.error('Login error:', err);
            setError(err.error || 'Giriş yapılırken bir hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    const handleForgotPassword = () => {
        navigate('/forgot-password');
    };

    return (
        <>
            <Header />
            <div className="login-container">
                <h1 className="system-title">Staj Takip Sistemi</h1>
                <div className="login-box">
                    <h2>Giriş Yap</h2>
                    
                    {error && <div className="error-message">{error}</div>}
                    
                    <form onSubmit={handleSubmit}>
                        <div className="input-group">
                            <label htmlFor="email">E-posta</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="E-posta adresinizi giriniz"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                disabled={loading}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="password">Şifre</label>
                            <div className="password-wrapper">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    name="password"
                                    placeholder="Şifrenizi giriniz"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                    disabled={loading}
                                />
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={togglePasswordVisibility}
                                    tabIndex="-1"
                                >
                                    <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                </button>
                            </div>
                        </div>
                        <div className="forgot-password">
                            <a href="#!" onClick={handleForgotPassword}>Şifremi unuttum</a>
                        </div>
                        <button 
                            type="submit" 
                            className="login-button"
                            disabled={loading}
                        >
                            {loading ? 'Giriş yapılıyor...' : 'Giriş'}
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Login;
